import { Item } from "../../../items/Item";
import { ComponentF } from "../../../../ui/ui";
import { vertLineDraw } from "../../../../ui/helpers";
import { RDisplay } from "../../../../ui/RotDisplay";
import Colors from "../../../Colors";
import { drawAttackDetails, drawShieldDetails } from "./attackDetails";
import { gameData } from "../../../GameManager";

const withColor = (c: string, s: string) => {
  return `%c{${c}}${s}%c{}`;
};
export const weaponInfoDraw = (
  display: RDisplay,
  x: number,
  y: number,
  width: number,
  item: Item
) => {
  const breed = item.breed;
  y += display.drawText(x, y, withColor(Colors.B_GREY_5, breed.name), width);
  const stats = breed.stats;
  if (stats) {
    y += display.drawText(
      x,
      y,
      withColor(Colors.B_GREY_5, `Weight: ${stats.weight}`),
      width
    );
  }

  y += 1;
  y += display.drawText(x, y, breed.info, width);
  y += 1;
  y += display.drawText(
    x,
    y,
    `%c{${Colors.B_GREY_3}}${item.breed.description}`,
    width
  );
  y += 1;
  const attacks = item.breed.attacks;
  if (attacks) {
    display.drawText(x, y, "One Handed");
    if (item.breed.attacks?.onehanded.blocks) {
      drawShieldDetails(
        display,
        gameData.player,
        attacks.onehanded,
        x,
        y,
        Math.floor(width / 2),
        Colors.B_GREY_5
      );
    } else {
      display.drawText(x, y, "One Handed");
      drawAttackDetails(
        display,
        gameData.player,
        attacks.onehanded,
        x,
        y,
        Math.floor(width / 2),
        Colors.B_GREY_5
      );
    }
    if (item.breed.attacks?.twohanded.blocks) {
      display.drawText(x + Math.floor(width / 2) + 1, y, "Two Handed");
      drawShieldDetails(
        display,
        gameData.player,
        attacks.twohanded,
        x + Math.floor(width / 2) + 1,
        y,
        Math.floor(width / 2),
        Colors.B_GREY_5
      );
    } else {
      display.drawText(x + Math.floor(width / 2) + 1, y, "Two Handed");
      drawAttackDetails(
        display,
        gameData.player,
        attacks.twohanded,
        x + Math.floor(width / 2) + 1,
        y,
        Math.floor(width / 2),
        Colors.B_GREY_5
      );
    }
  }
};

export const WeaponDisplay: ComponentF<{
  left: Item | null;
  right: Item | null;
}> = (C, { left, right }) => {
  const rightPane = Math.floor(C.bounds.w / 2) + C.bounds.x + 1;
  vertLineDraw(C.display, {
    x: rightPane - 1,
    y: C.bounds.y,
    w: 1,
    h: C.bounds.h,
  });

  if (left == null) {
    C.display.drawText(C.bounds.x, C.bounds.y, "Left Hand:");
    C.display.drawText(
      C.bounds.x,
      C.bounds.y + 1,
      `%c{${Colors.B_GREY_3}} None`
    );
  } else {
    C.display.drawText(C.bounds.x, C.bounds.y, `Left Hand:`);
    weaponInfoDraw(
      C.display,
      C.bounds.x,
      C.bounds.y + 2,
      rightPane - C.bounds.x,
      left
    );
  }
  if (right == null) {
    C.display.drawText(rightPane, C.bounds.y, "Right Hand:");
    C.display.drawText(
      rightPane,
      C.bounds.y + 1,
      `%c{${Colors.B_GREY_3}} None`
    );
  } else {
    C.display.drawText(rightPane, C.bounds.y, `Right Hand:`);
    weaponInfoDraw(
      C.display,
      rightPane,
      C.bounds.y + 1,
      C.bounds.w - 1 - rightPane,
      right
    );
  }
};
